import { render, staticRenderFns } from "./ClientIPMI.vue?vue&type=template&id=332c2fc6&scoped=true&"
import script from "./ClientIPMI.vue?vue&type=script&lang=js&"
export * from "./ClientIPMI.vue?vue&type=script&lang=js&"
import style0 from "./ClientIPMI.vue?vue&type=style&index=0&id=332c2fc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332c2fc6",
  null
  
)

export default component.exports